module Meevo.Plugins.ServicesWizard {

 
    import IntDetail = Meevo.Model.IntDetail;
   
    class MeevoServiceCategoryTabComponent implements ng.IComponentController {
      
        static $inject = [
            'meevo.plugins.servicesWizard.ServicesWizardService',
            'meevo.components.busy.BusyService',
            '$q'
        ];

     
        public selectedSecurityFeature: IntDetail;
        public serviceCategoryList: any;

        constructor(protected servicesWizardService: IServicesWizardService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $q: angular.IQService) {
            this.servicesWizardService.selectedServiceCatList = [];
        }

        $onInit() {
            this.loadServiceCategoryList();
        }

    
        loadServiceCategoryList(): ng.IPromise < void> {
            this.busyService.start();
            
            return new this.$q(resolve => {
                
                this.servicesWizardService.getServiceCategoryList().then((data) => resolve(data));

            }).then((data: any) => {
               this.serviceCategoryList = data;
            }).finally(() => {
                this.busyService.stop();
            });
        }

        checkedClick(item: any): void {
        
            if (Model.Guard.isNothing(this.servicesWizardService.selectedServiceCatList)) {
                this.servicesWizardService.selectedServiceCatList = [];
            }
            if (item.isChecked) {
                this.servicesWizardService.selectedServiceCatList.push({
                    id: item.cat_TId,
                    displayName: item.displayName,
                    matchExt_Cat_TId: item.matchExt_Cat_TId,
                    matchDN_Cat_TId: item.matchDN_Cat_TId
                });
            }
            else {
                this.servicesWizardService.selectedServiceCatList = _.reject(
                    this.servicesWizardService.selectedServiceCatList,
                    function(d) { return d.id === item.cat_TId; });
                }
          }


        private useEditMode() {
           

            this.busyService.start();
            this.$q
                .all([
                    //this.loadAlertCategoryList()
                ])
                .then(() => {
                    //this.params.alertSetting = _.find(this.alertSettingList, s => s.id === alert.alert_SId);
                    //this.params.alertCategory = _.find(this.alertCategoryList, c => c.id === alert.cat_SId);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

 }

    angular.module('meevo.plugins.servicesWizard')
        .component('meevoServiceCategoryTabComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/servicesWizard/optionTabs/tabs/serviceCategory/service-category-tab.component.html',
            controller: MeevoServiceCategoryTabComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}